import { Box, HStack, Grid } from '@chakra-ui/react';

import FeatureTooltip from './FeatureTooltip';
import Icon from './Icon';
import Text from './Text';

const featureTooltips: Record<string, string> = {
  'Up to 10–100 Code Frames':
    'Save and share standalone code snippets. Monthly: up to 10, Yearly & Lifetime: up to 100.',
  '10,000–20,000 Characters Limit':
    'Max characters per editor tab. Monthly: 10,000, Yearly & Lifetime: 20,000.',
};

const sharedFeaturesLearn = [
  '21 Real-World Projects',
  '100 Daily Coding Challenges',
  '40+ Practice Problems',
  'Figma Designs',
  'Test Cases',
  'Progress Tracking',
];

const sharedFeaturesBuild = [
  'Built-in Code Editor',
  'Merlin AI — 100K tokens/mo',
  '10 MB File Storage',
  'Prototypes',
  'Up to 10–100 Code Frames',
  '10,000–20,000 Characters Limit',
  'Private Code',
];

const sharedFeaturesCareer = ['CV Builder', 'Community Access'];

interface CategorySectionProps {
  label: string;
  color: string;
  dividerColor: string;
  features: string[];
}

const CategorySection = ({ label, color, dividerColor, features }: CategorySectionProps) => (
  <Box>
    <HStack spacing={2} mb={3}>
      <Text
        fontSize="micro"
        fontWeight="bold"
        textTransform="uppercase"
        letterSpacing="0.15em"
        style={{ fontSize: '10px', color }}
      >
        {label}
      </Text>
      <Box flex={1} h="1px" bg={dividerColor} />
    </HStack>
    <Grid templateColumns={['1fr', '1fr', '1fr 1fr']} gap={3}>
      {features.map((feature) => {
        const tooltip = featureTooltips[feature];
        return (
          <HStack key={feature} spacing={2.5} align="flex-start">
            <Box mt="2px" flexShrink={0}>
              <Icon type="Check" size={16} color={color} />
            </Box>
            <Text fontSize="small" opacity="secondary">
              {feature}
            </Text>
            {tooltip && <FeatureTooltip label={tooltip} />}
          </HStack>
        );
      })}
    </Grid>
  </Box>
);

export const FeaturesList = () => {
  return (
    <Box width="100%" maxW="750px" mx="auto" mt="80px" id="bds-features-list">
      <Box
        width="100%"
        px={[6, 6, 8]}
        py={[5, 5, 6]}
        borderRadius="2xl"
        borderWidth={1}
        borderColor="gray.700"
        bg="whiteAlpha.50"
      >
        <HStack spacing={2} mb={5}>
          <Icon type="PricingCheck" size={20} />
          <Text
            fontSize="small"
            fontWeight="semibold"
            textTransform="uppercase"
            letterSpacing="0.05em"
          >
            What&apos;s included in all plans
          </Text>
        </HStack>

        <Box display="flex" flexDirection="column" gap="24px">
          <CategorySection
            label="Learn"
            color="#9F7AEA"
            dividerColor="rgba(159, 122, 234, 0.15)"
            features={sharedFeaturesLearn}
          />
          <CategorySection
            label="Build"
            color="#ED8936"
            dividerColor="rgba(237, 137, 54, 0.15)"
            features={sharedFeaturesBuild}
          />
          <CategorySection
            label="Career"
            color="#48BB78"
            dividerColor="rgba(72, 187, 120, 0.15)"
            features={sharedFeaturesCareer}
          />
        </Box>
      </Box>
    </Box>
  );
};
